import "./Spinner.css";

export default function Spinner() {

    return <div className="spinner">
        <div className="spinner-red"></div>
        <div className="spinner-grey"></div>
    </div>
}